export default "__VITE_ASSET__CClWVwYH__"